import { unobserve, observe } from '@nx-js/observer-util';
import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';

export function useObservedState<S>(observer: () => S): S {
  const [observedState, setObservedState] = useState<S>(observer);

  // We don't need to use observedState as a dependency since the only way to
  // update the observedState is via the observer, and this could create a loop
  // of state changes. This is a known limitation of useEffect, and a solution
  // is "under construction":
  //
  // https://beta.reactjs.org/learn/removing-effect-dependencies#do-you-want-to-read-a-value-without-reacting-to-its-changes
  useEffect(() => {
    const observed = observe(() => {
      const newValue = observer();

      if (!isEqual(observedState, newValue)) {
        setObservedState(newValue);
      }
    });

    return () => unobserve(observed);
  }, [observer]); // eslint-disable-line react-hooks/exhaustive-deps

  return observedState;
}
